module.exports = __webpack_public_path__ + "siteminder_ico.png?7c60bfcff4b1223eb9cef1122e857778";